import { render } from "./RoutingFirewallRulesTab.vue?vue&type=template&id=6cb46894&scoped=true"
import script from "./RoutingFirewallRulesTab.vue?vue&type=script&lang=js"
export * from "./RoutingFirewallRulesTab.vue?vue&type=script&lang=js"

import "./RoutingFirewallRulesTab.vue?vue&type=style&index=0&id=6cb46894&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cb46894"]])

export default __exports__